<template>
    <v-layout column justify-center align-start>
        <v-breadcrumbs :items = '$store.state.breadcrumbs' class='pa-0 my-0' divider='>' style = 'user-select: none;'>
            <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
            </template>
        </v-breadcrumbs>
        <v-menu 
            fixed 
            transition = "slide-y-transition" 
            v-model = 'visibility.list_reports' 
            :close-on-content-click = 'false' 
            offset-y bottom left allow-overflow 
            :min-width = '$vuetify.breakpoint.name == "xs"? "95%":"60%"' 
            :max-width = '$vuetify.breakpoint.name == "xs"? "95%":"60%"' 
            class='px-0'
        >
            <template v-slot:activator="{ on }">
                <a class='px-0 nav_menu_toggle' v-on = 'on'>Отчеты <v-icon small>mdi-menu-down</v-icon></a>
            </template>
            <v-layout column>
                <v-card tile flat>
                    <v-layout class='px-5 pt-0 pb-4 ma-0'>
                        <v-text-field 
                            v-model = 'textFilter' 
                            append-icon='mdi-magnify' 
                            label='Поиск...' 
                            @focus = 'toggle.search = true;' 
                            @blur = 'toggle.search = false'
                            hide-details
                        ></v-text-field>
                    </v-layout>
                    <v-card-text class='px-5 py-0 ma-0'>
                        <v-layout column class='my-1 mb-4 px-0' style='max-height: 300px; overflow: auto;'>
                            <v-row no-gutters align-content = 'start' class = 'mb-2' style = 'min-height: initial; flex: 1 0 0% !important;'>
                                <v-col cols = '5'>
                                    <v-layout align-center>
                                        <v-btn icon small disabled><v-icon small>mdi-briefcase-outline</v-icon></v-btn>
                                        <span class = 'pl-1'>Проекты</span>
                                    </v-layout>
                                </v-col>
                                <v-col cols = '7' class = 'px-1'>
                                    <v-layout align-center>
                                        <v-btn icon small disabled><v-icon small>mdi-chart-donut</v-icon></v-btn>
                                        <span>Отчеты</span>
                                    </v-layout>
                                </v-col>
                            </v-row>
                            <template v-for = '(r,i) in groupedReports'>
                                <v-hover 
                                    v-if = 'i <= (lastIntersected + 10)'
                                    v-intersect = 'onIntersection'
                                    :data-index = 'i'
                                    :key = '`hover_${r.project_id}`' 
                                    :style = '$vuetify.breakpoint.smAndUp? "flex: 1 0 0% !important;":"min-height: initial; flex: 1 0 0% !important;"'
                                >
                                    <v-row no-gutters align-content = 'start' slot-scope="{ hover }">
                                        <v-col cols = '5'>
                                            <v-list-item class = 'px-0' :style = 'hover? "border-right: 1px solid red; height: 100%;":"height: 100%; padding-right: 1px;"'>
                                                <v-list-item-action class = 'mr-2'>
                                                    <v-btn 
                                                        :disabled = 'r.mode_persons == "0"' 
                                                        icon small 
                                                        :to = '{name: "project", params: {project_id: r.project_id}}' 
                                                        @click = 'visibility.list_reports = false;' 
                                                        class='ml-0 pl-0'
                                                    >
                                                        <v-icon small>mdi-settings-outline</v-icon>
                                                    </v-btn>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title :class='`body-2 ${hover? "font-weight-regular": "font-weight-light"}`'>{{r.project_name}}</v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action v-if = '!r.active' class = 'mr-2'>
                                                    <v-chip small outlined disabled>В архиве</v-chip>
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-col>
                                        <v-col cols = '7'>
                                            <v-list-item v-if = '!r.reports || r.reports.length == 0' class = 'px-1'></v-list-item>
                                            <v-layout column v-else>
                                                <v-list-item 
                                                    ripple 
                                                    v-for = "report in r.reports" 
                                                    :key = 'report.report_id' 
                                                    :to = '{name: "report", params: report}' 
                                                    @click = 'visibility.list_reports = false;'
                                                    class = 'px-1'
                                                >
                                                    <v-list-item-action class = 'mr-3'>
                                                        <v-btn v-if = '!$store.state.userData.meta.favorites.includes(report.report_id)' @click.prevent='$store.dispatch("addFavorite", report)' icon small>
                                                            <v-icon small>mdi-star-outline</v-icon>
                                                        </v-btn>
                                                        <v-btn v-else @click.prevent='$store.dispatch("delFavorite", report)' icon small>
                                                            <v-icon small>mdi-star</v-icon>
                                                        </v-btn>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title class='body-2 font-weight-light'>{{report.name}}</v-list-item-title>
                                                        <v-list-item-subtitle class='caption font-weight-light'>{{report.mode_name}}</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                    <v-list-item-action v-if = '!report.active' class = 'mr-2'>
                                                        <v-chip small outlined disabled>В архиве</v-chip>
                                                    </v-list-item-action>
                                                    <v-list-item-action v-if = 'report.expire_on'>
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator = '{ on }'>
                                                                <v-icon 
                                                                    small 
                                                                    v-on = 'on' 
                                                                    :color = 'diffTime(report.expire_on, currentMoment) > 24? "light-blue lighten-2": "red darken-2"'
                                                                >mdi-alert</v-icon>
                                                            </template>
                                                            <span>Доступ истекает {{formatTime(report.expire_on)}}</span>
                                                        </v-tooltip>
                                                    </v-list-item-action>
                                                </v-list-item>
                                            </v-layout>
                                        </v-col>
                                    </v-row>
                                </v-hover>
                                <v-layout 
                                    :key = '`loader_${r.project_id}`' 
                                    v-intersect = 'onIntersection'
                                    :data-index = 'i'
                                    column align-center justify-center 
                                    v-else
                                >
                                    <v-progress-circular 
                                        indeterminate 
                                        :color = '$store.getters.uiAccent' 
                                        size = '16' 
                                        width = '1'
                                        class = 'my-1'
                                    ></v-progress-circular>
                                </v-layout>
                            </template>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-layout>
            <v-layout 
                align-center py-1 
                :wrap = '!$vuetify.breakpoint.smAndUp'
                :style='`background: ${!$vuetify.theme.dark? "white":"#424242"};`' 
            >
                <project-create v-if = '$store.getters.currentUser.mode_projects'></project-create>
                <v-btn 
                    :class = '`${$vuetify.breakpoint.smAndUp? "ml-auto":"ml-4"} mr-2`' 
                    text @click = 'toggle.archive_projects = !toggle.archive_projects'
                >
                    <template v-if = '!toggle.archive_projects'>
                        <v-icon small left>mdi-package-down</v-icon>Архив проектов
                    </template>
                    <template v-else>
                        <v-icon small left>mdi-package-up</v-icon>Активные проекты
                    </template>
                </v-btn>
                <v-switch :class = '`my-auto mr-2 py-1 ${$vuetify.breakpoint.smAndUp? "":"ml-4"}`' v-model = 'toggle.archive_reports' hide-details>
                    <template v-slot:label>
                        <span class = 'body-2 font-weight-regular'>Отобразить архивные отчеты</span>
                    </template>
                </v-switch>
            </v-layout>
        </v-menu>
    </v-layout>
</template>
<script>
import ProjectCreateDialog from '@/components/entities/projects/CreateDialog.vue'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'

export default {
    name: 'MainMenu',
    components: {
        'project-create': ProjectCreateDialog
    },
    data() {
        return {
            toggle: {
                archive_projects: false,
                archive_reports: false,
                search: false
            },
            visibility: {
                create_project: false,
                list_reports: false
            },
            textFilter: '',
            lastIntersected: 0,
            clients: []
        }
    },
    computed: {
        currentMoment() {
            return dayjs()
        },
        groupedReports() {
            return Object.freeze(this.$store.getters.groupedReports(this.toggle.archive_projects, this.toggle.archive_reports, this.textFilter))
        },
    },
    watch: {
        toggle: {
            deep: true,
            handler(value) {
                if (value && value.archive_projects) {
                    this.$dataLayer.$emit('enrich', {
                    event: 'interaction',
                    data: {
                        type: 'change_view',
                        target: 'archive'
                    },
                    once: true
                    })
                }
            }
        }
    },
    methods: {
        formatTime(time) {
            return dayjs(time).format('D MMM YYYY')
        },
        diffTime(time1, time2) {
            return dayjs(time1).diff(dayjs(time2), 'hour')
        },
        onIntersection (e, o) {
            if (e[0].isIntersecting) {
                this.lastIntersected = parseInt(e[0].target.dataset.index)
            }
        }
    }
}
</script>
